import { createDialogContext } from 'ui-components';

export const LeftPanelContext = createDialogContext();
